// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"No-z","imageAndVideoCount":"Oo-z","imageAndVideoContainer":"Po-z","viewAllReviews":"Qo-z"};